import React from 'react';
import { TEXT_HIGHLIGHT_THEME, TextHighlightReact } from 'common/components/text-highlight';
import { Trans } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
import { react2panel } from 'common/util/react2panel';
export function CustomPropertyHelpText() {
  const {
    t
  } = useTranslation();
  return <Trans i18nKey={"custom-property.help-text"} t={t} components={{
    period: <TextHighlightReact text={"Period (.)"} theme={TEXT_HIGHLIGHT_THEME.GENERIC} size={"medium"} />,
    ctrlSpace: <TextHighlightReact text={"Control + Space"} theme={TEXT_HIGHLIGHT_THEME.GENERIC} size={"medium"} />
  }} data-sentry-element="Trans" data-sentry-component="CustomPropertyHelpText" data-sentry-source-file="help-text.tsx" />;
}
export const CustomPropertyHelpTextEl = react2panel("mp-custom-property-help-text", CustomPropertyHelpText);